import { api } from "./contract";
import {
  appleSignInRequest,
  emailSignInLinkRequest,
  emailSignInStartRequest,
  emailSignInStartResponse,
  emailSignInVerifyRequest,
  googleCodeSignInRequest,
  googleSignInRequest,
  standaloneSignInResponse,
} from "./standalone-auth.dto";

export const googleSignIn = api("POST", "/auth/google").withRequest(googleSignInRequest).withResponse(standaloneSignInResponse);

export const googleCodeSignIn = api("POST", "/auth/google/code").withRequest(googleCodeSignInRequest).withResponse(standaloneSignInResponse);

export const appleSignIn = api("POST", "/auth/apple").withRequest(appleSignInRequest).withResponse(standaloneSignInResponse);

export const emailSignInStart = api("POST", "/auth/email/start").withRequest(emailSignInStartRequest).withResponse(emailSignInStartResponse);

export const emailSignInVerify = api("POST", "/auth/email/verify").withRequest(emailSignInVerifyRequest).withResponse(standaloneSignInResponse);

export const emailSignInLink = api("GET", "/auth/email/link").withRequest(emailSignInLinkRequest);

const GOOGLE_AUTHORIZE_URL = "https://accounts.google.com/o/oauth2/v2/auth";

export const googleAuthorizeUrl = ({ clientId, redirectUri, state }: { clientId: string; redirectUri: string; state: string }): string => {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: "code",
    scope: "openid email profile",
    state,
    prompt: "select_account",
  });
  return `${GOOGLE_AUTHORIZE_URL}?${params.toString()}`;
};

// Any origin works: a next path is accepted only when resolving it keeps it on whatever origin it is resolved against.
const PLACEHOLDER_ORIGIN = "https://next.invalid";

// Whitespace, control characters and backslashes: browsers strip or rewrite them while parsing a URL (`/<tab>/evil.example`
// becomes `//evil.example`), so a path holding any of them is refused rather than cleaned.
const UNSAFE_CHARACTER = /[\s\\]|\p{Cc}/u;

const staysOnOrigin = (next: string): boolean => {
  try {
    return new URL(next, PLACEHOLDER_ORIGIN).origin === PLACEHOLDER_ORIGIN;
  } catch {
    return false;
  }
};

/** `next` when it is a path on this site (`/...`), else undefined: never another origin, a protocol-relative URL or a scheme. */
export const safeNextPath = (next: string | null | undefined): string | undefined => {
  if (next === undefined || next === null || !next.startsWith("/") || UNSAFE_CHARACTER.test(next)) {
    return undefined;
  }
  return staysOnOrigin(next) ? next : undefined;
};
